import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsAllSides2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowsAllSides2"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H9V5H5V9H3V3ZM15 3H21V9H19V5H15V3ZM5 15V19H9V21H3V15H5ZM21 15V21H15V19H19V15H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowsAllSides2;
